exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cartContainer{padding-bottom:20px}.cartRow{display:flex;padding:15px 0;border:1px solid #ccc;margin:5px 0}.cartRow__quantity{font-weight:400;text-align:right;flex-grow:1;padding-right:10px;align-self:flex-start}.cartRow__description{flex:8}.cartRow__name{padding:0;margin:0}.cartRow__modifiers{padding:5px}.cartRow__modifier{font-size:12px;padding:2px 0;margin:0}.cartRow__price{flex:3;text-align:right;font-weight:400;padding:0;margin:0;align-self:flex-start}.cartRow__remove{padding-left:20px;color:#ccc;background:none;border:none;cursor:pointer;align-self:flex-start}.cartTotal{padding:20px 10px 10px;display:flex;border-bottom:1px solid #ccc}.cartTotal__labels{flex-grow:3;text-align:right}.cartTotal__labels p{margin-bottom:10px}.cartTotal__amounts{flex-grow:1;text-align:right}.cartTotal__amounts p{margin-bottom:10px}.cartTotal__Item--total{font-weight:400}.cartFooter{padding-bottom:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/cart/cart.scss
// module id = 534
// module chunks = 0